import { createClient, SupabaseClient } from '@supabase/supabase-js';
import config from './environment';

const supabase: SupabaseClient = createClient(config.supabaseUrl, config.supabaseAnonKey);

export default supabase;
